import { gerarDadosBoleto } from './gerarDadosBoleto';
import { gerarPDF } from './gerarPDF';
import { gerarRemessa } from './gerarRemessa';
import { gerarRetorno } from './gerarRetorno';

export const ailos = {
  gerarDadosBoleto,
  gerarPDF,
  gerarRemessa,
  gerarRetorno,
};
